import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Big from 'big.js';
import { formatAmount } from '../formatAmount';
import { compareComplexProps } from 'helpers/memo';
import TradeItem from '../TradeItem';
import styles from './styles.module.scss';
import sharedStyles from '../styles.module.scss';

Big.RM = 0;

function Order({ item, side, maxQty, market, onClick }) {
  const isUp = side === 'buys';
  const price = formatAmount(item.price, market.minTick, market.minTickLength);
  const quantity = formatAmount(item.quantity, market.minQty, market.minQtyLength);
  const total = formatAmount(Big(item.quantity).times(item.price), market.minTick, market.minTickLength);

  const setOrderAmount = () => {
    onClick({ order: { qty: `${item.quantity}`, price: null }, side });
  };

  const setOrderPrice = () => {
    onClick({ order: { qty: null, price: `${item.price}` }, side });
  };

  const amountGraphWidth = (item.quantity / maxQty) * 100;

  return (
    <tr
      className={classnames([sharedStyles.tableRow, styles.orderRow], {
        [styles.orderSell]: side === 'sells',
        [styles.orderBuy]: side === 'buys'
      })}>
      <td className={styles.amountGraphCell}>
        <div
          className={styles.amountGraph}
          style={{
            width: `${amountGraphWidth}%`,
            backgroundColor: side === 'buys' ? 'var(--color-green-clear)' : 'var(--color-red-clear)'
          }}
        />
      </td>
      <td className={sharedStyles.tableCell}>
        <TradeItem title={item.price} isUp={isUp} onClick={setOrderPrice} rightAligned>
          {price}
        </TradeItem>
      </td>
      <td className={sharedStyles.tableCell}>
        <TradeItem title={item.quantity} onClick={setOrderAmount} rightAligned>
          {quantity}
        </TradeItem>
      </td>
      <td className={sharedStyles.tableCell}>
        <TradeItem muted title={total} rightAligned>
          {total}
        </TradeItem>
      </td>
    </tr>
  );
}

Order.propTypes = {
  item: PropTypes.object.isRequired,
  side: PropTypes.string.isRequired,
  maxQty: PropTypes.string.isRequired,
  market: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired
};

export default memo(Order, compareComplexProps);
